// app/javascript/outbound_spoonflower.js
document.addEventListener("click", (e) => {
  const a = e.target.closest("a[data-outbound='spoonflower']");
  if (!a) return;

  if (window.gtag) {
    window.gtag("event", "outbound_spoonflower_click", {
      link_url: a.href,
      colorway: a.dataset.colorway || null
    });
  }
});